import type { ServerNode } from './types';
import type { ConditionNodeData } from '../nodes/ConditionNode';
import { conditionCodeToTitle } from '../utils/conditionCodeMapping';
import { getConditionStrategy } from './conditionStrategies';

/**
 * Converts a server Condition.* node into a ConditionNodeData object
 * that the existing ConditionNode component and ConditionConfigPanel can consume.
 *
 * Field-name translations (server → UI):
 *   config.matchMode  → matchType
 *   config.schedule   → runSchedule
 *   config.numbers    → phoneNumbers
 */
export function hydrateConditionData(node: ServerNode): ConditionNodeData {
    const { config, type } = node;

    const base: ConditionNodeData = {
        conditionCode: type,
        isPlaceholder: false,
        title: conditionCodeToTitle(type) ?? 'When to continue',
    };

    const strategy = getConditionStrategy(type);
    if (!strategy) return base;

    return { ...base, ...strategy.hydrate(config) };
}
